'use strict';

var React = require('react');

var SvgMeasurementSizeIcon = function SvgMeasurementSizeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.75 5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-1.5c-.414 0-.75.336-.75.75s.336.75.75.75h1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 6.5c-.414 0-.75-.336-.75-.75s-.336-.75-.75-.75-.75-.336-.75-.75.336-.75.75-.75c1.243 0 2.25 1.007 2.25 2.25 0 .414-.336.75-.75.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 7.5c.414 0 .75.336.75.75v1.5c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-1.5c0-.414.336-.75.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25 12c-.414 0-.75-.336-.75-.75v-5.19l-.97.97c-.293.293-.767.293-1.06 0-.293-.293-.293-.767 0-1.06l2.25-2.25c.293-.293.767-.293 1.06 0l2.25 2.25c.293.293.293.767 0 1.06-.293.293-.767.293-1.06 0l-.97-.97v5.19c0 .414-.336.75-.75.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 13c-.414 0-.75.336-.75.75s.336.75.75.75h5.19l-.97.97c-.293.293-.293.767 0 1.06.293.293.767.293 1.06 0l2.25-2.25c.293-.293.293-.767 0-1.06l-2.25-2.25c-.293-.293-.767-.293-1.06 0-.293.293-.293.767 0 1.06l.97.97h-5.19Z"
  }));
};
SvgMeasurementSizeIcon.displayName = "MeasurementSizeIcon";

exports.SvgMeasurementSizeIcon = SvgMeasurementSizeIcon;
